/** Select a visible panel even when Shopify theme blocks are absent from section.blocks. */
class KBeforeAfter extends HTMLElement {
  connectedCallback() {
    const radios = Array.from(this.querySelectorAll('.ba-item__input'));
    const active = radios.find((radio) => radio.checked) || radios[0];
    if (active) active.checked = true;
  }
}
if (!customElements.get('k-before-after')) customElements.define('k-before-after', KBeforeAfter);
